/* ============================================================
   DOGS SUPREME · <ds-tm-rechner>
   Etiketten-Vergleich: Protein auf Trockenmasse (Navigator P4,
   docs/navigator-plattform.md).

   Fachlogik (identisch Flagship-Artikel):
     TM-Protein % = Rohprotein / (100 - Feuchtigkeit) * 100
   Etikettwerte sind erst auf Trockenmasse vergleichbar: Nassfutter
   wirkt auf dem Etikett niedriger, weil Wasser mitgewogen wird.

   · Zwei Futter (A/B) nebeneinander, je Rohprotein + Feuchtigkeit,
     Feuchte-Schnellwahl (Trocken ~10 %, Nass/BARF ~75 %, eigener Wert).
   · Ergebnis neutral: Zahlen + EIN Einordnungssatz. KEIN Marken-Scoring,
     keine gut/schlecht-Wertung (UWG).
   · SLOT eigene Deklaration (Platzhalter-Prinzip): Attribute
     own-name/own-protein/own-moisture/own-url. Leer = Abschnitt
     erscheint NICHT. Erst nach API-verifizierter Analytik befuellen.

   UI-Schicht: assets/ds-nav-foundation.css (.dsn-*), Spec
   docs/standards/navigator-design-spec.md.
   Kompatibilitaet wie ds-audio.js. Kein localStorage (zustandslos).
   ============================================================ */
(function () {
  'use strict';

  function round1(n) { return Math.round(n * 10) / 10; }

  /* TM-Protein in Prozent oder null bei unplausiblen Werten. */
  function tmPercent(protein, moisture) {
    if (typeof protein !== 'number' || typeof moisture !== 'number') return null;
    if (!isFinite(protein) || !isFinite(moisture)) return null;
    if (protein <= 0 || protein > 90) return null;
    if (moisture < 0 || moisture > 95) return null;
    return round1(protein / (100 - moisture) * 100);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { tmPercent: tmPercent, round1: round1 };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-tm-rechner')) return;

  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-tm-rechner"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-tm-rechner\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-tm-rechner-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-tm-rechner-styles';
    style.textContent = [
      "ds-tm-rechner .dstm-cols{display:grid;grid-template-columns:1fr 1fr;gap:14px}",
      "ds-tm-rechner .dstm-col{background:#f5f5f7;border-radius:16px;padding:16px}",
      "ds-tm-rechner .dstm-col-title{font-size:15px;font-weight:600;color:#1d1d1f;margin:0 0 12px;letter-spacing:-.01em}",
      "ds-tm-rechner .dstm-group{margin-bottom:12px}",
      "ds-tm-rechner .dstm-btn-row{margin-top:16px}",
      "ds-tm-rechner .dstm-result{display:none;margin-top:18px}",
      "ds-tm-rechner .dstm-result.dstm-show{display:block}",
      "ds-tm-rechner .dstm-res-cols{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:0 0 14px}",
      "ds-tm-rechner .dstm-res-box{background:#fff;border:1px solid rgba(0,0,0,.07);border-radius:12px;padding:14px;text-align:center}",
      "ds-tm-rechner .dstm-res-label{font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:.5px;color:#6e6e73;margin:0 0 4px}",
      "ds-tm-rechner .dstm-res-num{font-size:28px;font-weight:700;color:#1d1d1f;letter-spacing:-.02em;margin:0;font-variant-numeric:tabular-nums}",
      "ds-tm-rechner .dstm-res-raw{font-size:12px;color:#6e6e73;margin:4px 0 0;font-variant-numeric:tabular-nums}",
      "@media (max-width:480px){ds-tm-rechner .dstm-cols{grid-template-columns:1fr}",
      "ds-tm-rechner .dstm-res-cols{grid-template-columns:1fr 1fr}}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>';

  function numInput(id, placeholder) {
    var input = el('input', 'dsn-input');
    input.id = id; input.type = 'number'; input.step = '0.1';
    input.min = '0'; input.max = '100'; input.placeholder = placeholder;
    input.setAttribute('inputmode', 'decimal');
    input.addEventListener('input', function () { input.classList.remove('dsn-invalid'); });
    return input;
  }

  function parseNum(input) {
    var v = parseFloat(String(input.value).replace(',', '.'));
    return isFinite(v) ? v : NaN;
  }

  function fmt(n) { return String(n).replace('.', ','); }

  class DsTmRechner extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();
      this.render();
    }

    column(letter) {
      var col = el('div', 'dstm-col');
      col.appendChild(el('p', 'dstm-col-title', 'Futter ' + letter));

      var g1 = el('div', 'dstm-group');
      var l1 = el('label', 'dsn-label', 'Rohprotein laut Etikett in %');
      l1.setAttribute('for', 'DstmP' + letter);
      g1.appendChild(l1);
      var p = numInput('DstmP' + letter, letter === 'A' ? 'z. B. 22' : 'z. B. 8');
      g1.appendChild(p);
      col.appendChild(g1);

      var g2 = el('div', 'dstm-group');
      var l2 = el('label', 'dsn-label', 'Feuchtigkeit in %');
      l2.setAttribute('for', 'DstmF' + letter);
      g2.appendChild(l2);
      var f = numInput('DstmF' + letter, letter === 'A' ? 'z. B. 10' : 'z. B. 75');
      g2.appendChild(f);
      var chips = el('div', 'dsn-chip-row');
      [['Trocken ~10 %', '10'], ['Nass/BARF ~75 %', '75']].forEach(function (c) {
        var chip = el('button', 'dsn-chip', c[0]);
        chip.type = 'button';
        chip.addEventListener('click', function () { f.value = c[1]; f.classList.remove('dsn-invalid'); });
        chips.appendChild(chip);
      });
      g2.appendChild(chips);
      col.appendChild(g2);

      return { root: col, protein: p, moisture: f };
    }

    render() {
      var self = this;
      var card = el('div', 'dsn-card');
      card.appendChild(el('p', 'dsn-title', 'Protein auf Trockenmasse umrechnen'));
      card.appendChild(el('p', 'dsn-sub',
        'Trage die Etikettwerte von zwei Futtern ein. Erst ohne das Wasser gerechnet werden die Zahlen vergleichbar.'));

      var cols = el('div', 'dstm-cols');
      this.a = this.column('A');
      this.b = this.column('B');
      cols.appendChild(this.a.root);
      cols.appendChild(this.b.root);
      card.appendChild(cols);

      var btnRow = el('div', 'dstm-btn-row');
      var btn = el('button', 'dsn-btn', 'Vergleichen');
      btn.type = 'button';
      btn.style.width = '100%';
      btnRow.appendChild(btn);
      card.appendChild(btnRow);

      this.result = el('div', 'dstm-result');
      this.result.setAttribute('aria-live', 'polite');
      card.appendChild(this.result);

      btn.addEventListener('click', function () { self.calc(); });

      this.appendChild(card);
    }

    clearResult() { while (this.result.firstChild) this.result.removeChild(this.result.firstChild); }

    calc() {
      this.clearResult();
      var pa = parseNum(this.a.protein), fa = parseNum(this.a.moisture);
      var pb = parseNum(this.b.protein), fb = parseNum(this.b.moisture);
      var ta = tmPercent(pa, fa), tb = tmPercent(pb, fb);

      var bad = false;
      if (ta === null) {
        this.a.protein.classList.add('dsn-invalid');
        this.a.moisture.classList.add('dsn-invalid');
        bad = true;
      }
      if (tb === null) {
        this.b.protein.classList.add('dsn-invalid');
        this.b.moisture.classList.add('dsn-invalid');
        bad = true;
      }
      if (bad) { this.result.classList.remove('dstm-show'); return; }

      var box = el('div', 'dsn-result dsn-step-in');

      var resCols = el('div', 'dstm-res-cols');
      [['A', ta, pa, fa], ['B', tb, pb, fb]].forEach(function (r) {
        var rb = el('div', 'dstm-res-box');
        rb.appendChild(el('p', 'dstm-res-label', 'Futter ' + r[0]));
        rb.appendChild(el('p', 'dstm-res-num', fmt(r[1]) + '\u00A0%'));
        rb.appendChild(el('p', 'dstm-res-raw', 'Etikett: ' + fmt(r[2]) + ' % bei ' + fmt(r[3]) + '\u00A0% Feuchte'));
        resCols.appendChild(rb);
      });
      box.appendChild(resCols);

      var verdict;
      var diff = round1(Math.abs(ta - tb));
      if (diff < 1) {
        verdict = 'In der Trockenmasse liegen beide praktisch gleichauf. Der Unterschied auf dem Etikett kommt vor allem vom Wassergehalt.';
      } else {
        var hi = ta > tb ? 'A' : 'B';
        verdict = 'In der Trockenmasse liefert Futter ' + hi + ' den höheren Proteinanteil, Abstand ' + fmt(diff) + '\u00A0Prozentpunkte. Auf dem Etikett war das so nicht ablesbar, weil Wasser mitgewogen wird.';
      }
      box.appendChild(el('p', 'dsn-text', verdict));
      box.appendChild(el('p', 'dsn-note',
        'Die Rechnung ordnet nur die Deklaration ein. Wie gut ein Hund das Protein verwerten kann, hängt zusätzlich von Quelle und Verarbeitung ab, das zeigt keine Etikettzahl.'));

      /* SLOT eigene Deklaration: erscheint nur mit gepflegten Attributen. */
      var op = parseFloat(this.getAttribute('own-protein') || '');
      var om = parseFloat(this.getAttribute('own-moisture') || '');
      var ot = tmPercent(op, om);
      var oname = this.getAttribute('own-name') || '';
      var ourl = this.getAttribute('own-url') || '';
      if (ot !== null && oname && ourl) {
        var own = el('p', 'dsn-note');
        own.appendChild(document.createTextNode('Zum Einordnen: ' + oname + ' deklariert ' + fmt(op) + '\u00A0% Rohprotein bei ' + fmt(om) + '\u00A0% Feuchte, das sind ' + fmt(ot) + '\u00A0% in der Trockenmasse. '));
        var link = el('a', 'dsn-cta', 'Zur Deklaration');
        link.href = ourl + (ourl.indexOf('?') === -1 ? '?' : '&') + 'utm_source=ai-bridge';
        link.setAttribute('data-event', 'ai_bridge_click_trockenmasse_rechner_eigenfutter');
        var arrow = el('span', '');
        arrow.innerHTML = ARROW_SVG;
        arrow.setAttribute('aria-hidden', 'true');
        link.appendChild(arrow);
        own.appendChild(link);
        box.appendChild(own);
      }

      this.result.appendChild(box);
      this.result.classList.add('dstm-show');
    }
  }

  customElements.define('ds-tm-rechner', DsTmRechner);
})();
